import { ExternalCostModalPartial } from "../../../../partials/admin/menus/proposals/external-cost-modal.admin.partial";

export const ExternalCostModalScreen: React.FunctionComponent = () => {
  return <ExternalCostModalPartial />;
};
